import { useRef } from "react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { ArrowLeft, ArrowRight } from "~/design-system/components";
import { FancyBox } from "~/modules/shared/components";
import { Flavor } from "../types";

type FlavorListsSliderProps = {
  flavorList: Flavor[];
};

export function FlavorListsSlider({ flavorList }: FlavorListsSliderProps) {
  const prevRef = useRef<HTMLButtonElement>(null);

  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <FancyBox className="relative">
      <Swiper
        slidesPerView={1}
        breakpoints={{
          768: {
            slidesPerView: 2,
          },
          1024: {
            spaceBetween: 50,
            slidesPerView: 2,
          },
        }}
        onBeforeInit={(swiper) => {
          if (
            typeof swiper.params.navigation !== "boolean" &&
            swiper.params.navigation
          ) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        modules={[Navigation]}
      >
        {[...flavorList].reverse().map((flavor, index) => (
          <SwiperSlide key={index} className="overflow-hidden rounded-2xl border">
            <a
              href="/"
              data-fancybox="flavor-list"
              data-src={flavor.image.url}
            >
              <img
                src={flavor.image.url}
                alt={flavor.name}
                width={500}
                height={500}
                className="lg:h-screen h-[82vh] w-full scale-105 object-center"
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation Buttons */}
      <div className="pointer-events-none absolute top-1/2 left-0 z-30 flex w-full -translate-y-1/2 justify-between px-4">
        <button
          ref={prevRef}
          className="border-primary-default text-primary-default hover:bg-primary-default pointer-events-auto flex h-12 w-12 cursor-pointer items-center justify-center rounded-full border bg-white/80 shadow-md transition-all hover:text-white disabled:cursor-not-allowed disabled:opacity-30"
        >
          <ArrowLeft />
        </button>
        <button
          ref={nextRef}
          className="border-primary-default text-primary-default hover:bg-primary-default pointer-events-auto flex h-12 w-12 cursor-pointer items-center justify-center rounded-full border bg-white/80 shadow-md transition-all hover:text-white disabled:cursor-not-allowed disabled:opacity-30"
        >
          <ArrowRight />
        </button>
      </div>
    </FancyBox>
  );
}
